
import { Component, Prop, Vue } from "vue-property-decorator";
import { Next, Route } from 'vue-router';
import  ButtonVue from "@/lib/Button.vue";

import { IUser } from "@/../../server/src/user/IUser";
import Bus from "@/lib/Bus"; const bus: Bus = new Bus().getBus();

@Component({ async beforeRouteEnter(to: Route, from: Route, next: Next<DbgVue>) {
            console.log("beforeRouteEnter:", to.path)
            next((vm: DbgVue) => {  });
        },
        components: {  ButtonVue } 
        })

export default class DbgVue extends Vue {

  @Prop(Object) obj: any;
  @Prop(Array) arr: any;
  @Prop(String) title: string|undefined;
  @Prop(Array) emails: any;

  user:IUser=bus.get_user();
  key:number=0;

  dbg:number=0;


  async mounted() {   

    if (!this.user) return;
    if (!this.user.data_email) return;

    if (this.emails) {
      let found=0
      for (let i=0;i<this.emails.length;i++) {
        if (this.user.data_email.indexOf(this.emails[i])>-1) found=1
      }
      if (!found) return;
    }

    if (this.obj || this.arr) this.key++;  
  }

  dbg_switch() {
    if (this.dbg) this.dbg=0;
    else this.dbg=1;
    this.key++
  }

}
